import { dropdownMenu } from '@atoms/dropdown-menu';

export default () => {
  dropdownMenu('anonymous');
  document.querySelector('.nav-anonymous-desktop')?.setAttribute('data-ready', 'true');
};
